import { UserRole } from 'types';

/**
 * Role sets that gate palette commands / actions and the search fan-out. These
 * mirror the visibility rules in `organisms/Menu/MenuContainer` and
 * `router/AppRouter#getRoutesByRole` so the palette never surfaces a destination
 * the current operator has no route to.
 */
export const STUDENT_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.SALESMANAGER,
  UserRole.FINANCIER,
];

export const EDUCATION_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.SALESMANAGER,
  UserRole.HRMANAGER,
];

export const FINANCE_VIEW_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.FINANCIER,
  UserRole.ACCOUNTANT,
  UserRole.SALESMANAGER,
];

export const FINANCE_EXPENSE_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.FINANCIER,
  UserRole.ACCOUNTANT,
];

export const FINANCE_PLAN_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.FINANCIER,
];

export const ADMIN_ROLES: UserRole[] = [UserRole.ADMIN];

export const ZOOM_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.METHODIST,
];

export const PERFORMANCE_ROLES: UserRole[] = [
  UserRole.ADMIN,
  UserRole.ACCOUNTANT,
  UserRole.HRMANAGER,
];

/**
 * `true` when `allowed` is undefined (visible to any logged-in operator) or the
 * operator holds at least one of the allowed roles.
 */
export const visibleFor = (roles: UserRole[], allowed?: UserRole[]): boolean =>
  !allowed || roles.some((role) => allowed.includes(role));
